var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.sectorList),function(s){return _c('div',{key:s.id,staticClass:"my-1"},[_c('a',{staticClass:"text-dark",class:[!s.parent?'font-weight-bold':'' ]},[_vm._v("• "+_vm._s(s.name))]),_c('div',{staticClass:"ml-4"},[_c('SelectedSectorView',{attrs:{"sectors":_vm.sectors,"parent-id":s.id}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }